export enum UserAuthSteps{
    REGISTER = 0,
    LOGIN = 1
  }